import React, { Component } from 'react';
import { Provider } from 'react-redux';

import I18n from './i18n.container';
import ErrorBoundary from './error-boundary';

class Root extends Component {
  render() {
    const { store, children } = this.props;

    return (
      <ErrorBoundary>
        <Provider store={store}>
          <I18n>
            {children}
          </I18n>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/components/root.js